import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { HelpdeskDtoKeyEnum } from '@zaoblako/shared/modules/helpdesk/enum/helpdesk-dto-key.enum';

import * as yup from 'yup';

export interface HelpdeskEmailFindInterface {
  id: number;
  username: string;
  password: string;
  tls: boolean;
  host: string;
  portIMAP: number;
  portSMTP: number;
  isMain: boolean;
}

export const HelpdeskEmailFindDto = SerdeDtoClass.create<HelpdeskEmailFindInterface>(HelpdeskDtoKeyEnum.HELPDESK_TASK_EMAIL_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  username: {
    label: 'Имя',
    serializer: yup.string(),
  },
  password: {
    label: 'Пароль',
    serializer: yup.string(),
  },
  tls: {
    label: 'TLS-соединение',
    serializer: yup.boolean(),
  },
  host: {
    label: 'Хост',
    serializer: yup.string(),
  },
  portIMAP: {
    label: 'Порт IMAP',
    serializer: yup.number(),
  },
  portSMTP: {
    label: 'Порт SMTP',
    serializer: yup.number(),
  },
  isMain: {
    label: 'Главный',
    serializer: yup.boolean(),
  },
});
